export const getUserNameLastName = (fullname: string) => {
  const fullnameArray = fullname.split(' ');
  return `${fullnameArray[1]} ${fullnameArray[0]}`;
};
